import { __awaiter } from 'tslib';

const ENDPOINT = 'POSTverifysession';
function postVerifySession(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(postVerifySession.endpoint, params, params, customURL, customHeaders, null, isKoussa);
    });
}
postVerifySession.endpoint = ENDPOINT;

export { postVerifySession as default };
//# sourceMappingURL=postVerifySession.js.map
